import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import {MatSelect} from '@angular/material/select';
import {MatSelectFilterComponent} from 'mat-select-filter';
import {SearchObject} from 'src/app/domain/search/SearchObject';
import {SearchObjectService} from 'src/app/modules/services/search-object/SearchObjectService';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ToastService} from 'src/app/modules/toast/toast.service';
import {hasrequiredField} from 'src/app/utils/Hasrequired';

@Component({
    selector: 'app-combo-pme',
    templateUrl: './combo-pme.component.html',
    styleUrls: ['./combo-pme.component.css']
})
export class ComboPmeComponent implements OnInit {

    @Input() control: FormControl;
    @Input() label = 'test';
    searchObject: SearchObject = new SearchObject();
    list: string[] = [];
    listsearch: string[] = [];
    isLoading = false;
    required = hasrequiredField;
    @ViewChild('MatSelect') select: MatSelect;
    @Input() muliple = false;
    @Input() withfiltre = false;
    @ViewChild(MatSelectFilterComponent) filter: MatSelectFilterComponent;
    motcle: string;

    constructor(
        private appTranslateService: AppTranslateService,
        private toastService: ToastService, private searchObjectService: SearchObjectService
    ) {
    }

    get isReady() {
        return Array.isArray(this.list);
    }

    ngOnInit(): void {
        this.fetchlist();
    }

    change(e) {
        this.filter?.searchForm.reset();
        // this.filter.filteredReturn.emit(this.options)
        // this.filter.input=""
    }

    getlang() {
        return this.appTranslateService.getDefaultLang();
    }

    clear($event: MouseEvent) {
        $event.stopPropagation();
        this.control.setValue(undefined);
    }

    ngAfterViewInit(): void {
        this.fetchlist();
    }

    private fetchlist() {
        this.isLoading = true;

        this.list = ['oui', 'non'];

        this.listsearch = ['oui', 'non'];
        this.listsearch?.map(
            (item) => (item = this.motcle)
        );

    }
}
